import { ScannerProvider } from './types'
import { ScanbotScannerProvider } from './scanbot/ScanbotScannerProvider'
import { CortexScannerProvider } from './cortex/CortexScannerProvider'

export class ScannerFactory {
  static async createScanner(
    useScanbotScanner: boolean
  ): Promise<ScannerProvider> {
    if (useScanbotScanner) {
      return new ScanbotScannerProvider()
    }
    return new CortexScannerProvider()
  }
}
